import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.message.send;

export const sendMessageErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    }
});
export const sendMessageLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING;
});

export const sendMessageSuccessSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.SUCCESS;
});
export const sendMessageShowModal = createSelector([baseState], (state) => {
    return state.show;
});
export const sendMessageDataSelector = createSelector([baseState], (state) => {
    return {
        name: state.name,
        id: state.id
    };
});